module.exports = __webpack_public_path__ + "img/icon-differentials_01.0c17999a.svg";